import { ContextMenuItem } from "@shared/EDS/components/ContextMenuItem";
import { useToggleChangeability } from "./useToggleChangeability";
import { Changeability } from "@opstel/query/v2/models/action";

export type SBDActionContextMenuItemsProps = {
  readonly actionId: string;
  readonly currentChangeability: Changeability;
};

export function SBDActionContextMenuItems({
  actionId,
  currentChangeability,
}: SBDActionContextMenuItemsProps) {
  const {
    canToggleChangeabilityQuery: { isFetching, data: isChangeable },
    toggleChangeability,
  } = useToggleChangeability({
    actionId,
    currentChangeability,
  });

  if (isFetching || isChangeable === undefined) {
    return undefined;
  }

  return (
    <div>
      <ContextMenuItem
        iconName={currentChangeability === "Open" ? "lock" : "lock-open"}
        text={currentChangeability === "Open" ? "Actie vastzetten" : "Actie losmaken"}
        disabled={!isChangeable.canUpdate}
        onSelect={toggleChangeability}
        tooltipContent={isChangeable.description}
      />
    </div>
  );
}
